// Chakra imports
import { Text, useColorModeValue, Grid } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card.js';
import React from 'react';
import EditableInformation from './EditableInformation';

export default function EmergencyData(props) {
  const { studentData, isEditing = false, onFieldChange } = props;

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'gray.400';
  const cardShadow = useColorModeValue(
    '0px 18px 40px rgba(112, 144, 176, 0.12)',
    'unset',
  );
  return (
    <Card mb={{ base: '0px', '2xl': '20px' }}>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Datos de emergencia
      </Text>
      <Grid
        templateColumns={{
          base: "1fr",
          lg: "1fr 1fr",
        }}
        templateRows={{
          base: "repeat(3, 1fr)",
          lg: "1fr",
        }}
        gap={{ base: "20px", xl: "20px" }}
        mt={{ base: "20px", lg: "20px" }}>
      <EditableInformation
        mb={2}
        boxShadow={cardShadow}
        title="Contacto de emergencia"
        value={studentData?.emergencyContact}
        isEditing={isEditing}
        field="emergencyContact"
        onFieldChange={onFieldChange}
      />
      <EditableInformation
        mb={2}
        boxShadow={cardShadow}
        title="Teléfono de contacto"
        value={studentData?.emergencyContactPhone}
        isEditing={isEditing}
        field="emergencyContactPhone"
        type="tel"
        onFieldChange={onFieldChange}
      />
      <EditableInformation
        mb={2}
        boxShadow={cardShadow}
        title="Sociedad médica"
        value={studentData?.medicalInsurance}
        isEditing={isEditing}
        field="medicalInsurance"
        onFieldChange={onFieldChange}
      />
      <EditableInformation
        mb={2}
        boxShadow={cardShadow}
        title="Emergencia móvil"
        value={studentData?.mobileEmergency}
        isEditing={isEditing}
        field="mobileEmergency"
        onFieldChange={onFieldChange}
      />
      </Grid>
    </Card>
  );
}
